import { usingGet } from '@ocean/api'

export const searchRequirements = (text: string = '') =>
  usingGet(`Search/Requirements?query=${text}`, { useProxy: true })

export const searchLibrary = (text: string = '') =>
  usingGet(`Search/Library?query=${text}`, { useProxy: true })
